import React from 'react';
import styles from './TextContent.module.scss';

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

type TextContentProps = Omit<DivProps, 'dangerouslySetInnerHTML'> & {
  children?: React.ReactNode,
};

export function TextContent({ children, ...props }: TextContentProps) {

  return (
    <div className={ styles.textContent } { ...props }>
      { children }
    </div>
  );
}
